const translations = {};

export function setTranslations(t) {
    Object.assign(translations, t);
}

export function getTranslations() {
    return translations;
}



// WEBPACK FOOTER //
// ./~/@99designs/globalnav/locale-data/index.js